import React, {useState, useEffect} from 'react';
import {useCookies} from "react-cookie";

function MouseTracker() {
    const [mousePath, setMousePath] = useState([]);
    const [cookies] = useCookies(['session-token']);

    useEffect(() => {
        const handleMouseMove = (event) => {
            setMousePath((prevPath) => [
                ...prevPath,
                {
                    x: event.clientX,
                    y: event.clientY,
                    timestamp: Date.now(),
                },
            ]);
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    useEffect(() => {
        if (mousePath.length > 0) {
            localStorage.setItem('mousePath', JSON.stringify(mousePath));
        }
    }, [mousePath]);

    useEffect(() => {
        const sendDataToBackend = async () => {
            try {
                const storedPath = localStorage.getItem('mousePath');
                if (storedPath) {
                    const pathToSend = JSON.parse(storedPath);

                    // Only send if there is data to send
                    if (pathToSend.length === 0) return;

                    console.log('Sending data...', pathToSend);

                    // Send data to backend here
                    const response = await fetch('/api/mouse_path', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            session: cookies['session-token'] || 'ERROR_SESSION_COOKIE_MISSING',
                            data: pathToSend
                        }),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    // Clear the stored path after successful send
                    localStorage.removeItem('mousePath');
                    setMousePath([]); // Clear the state
                    console.log('Data sent successfully:', pathToSend);
                }
            } catch (error) {
                console.error('Error sending data:', error);
                // Implement retry mechanism or error handling here
            }
        };

        // Set up the interval once and store its ID
        const intervalId = setInterval(sendDataToBackend, 500);

        // The cleanup function will be called when the component unmounts
        return () => {
            // Use clearInterval to properly clean up the interval
            clearInterval(intervalId);
        };
    }, []);

    return (
        <div>
        </div>
    );
}

export default MouseTracker;